import { jsx as _jsx } from "react/jsx-runtime";
import { Card, getTestId, GradientView } from '@airtel/air-design-system';
export var SingleOfferCardWrapper = props => {
  var parentType = props.parentType,
    children = props.children,
    showCard = props.showCard,
    _props$gradientType = props.gradientType,
    gradientType = _props$gradientType === void 0 ? 'MANTLE' : _props$gradientType,
    showShadow = props.showShadow,
    noCardProps = props.noCardProps,
    testID = props.testID,
    style = props.style;
  var WrapperComponent = parentType === 'GRADIENT' ? GradientView : Card;
  var wrapperProps = parentType === 'GRADIENT' ? {
    type: gradientType
  } : Object.assign(Object.assign({
    noPadding: true
  }, !showCard && noCardProps), {
    showShadow
  });
  return _jsx(WrapperComponent, Object.assign({}, getTestId(testID, parentType === 'GRADIENT' ? 'GradientView' : 'Card'), {
    style: style
  }, wrapperProps, {
    children: children
  }));
};